import React, { useEffect, useRef, useState } from "react";
import Layout from "../../components/vendorManager/Layout";
import Helmet from "react-helmet";
import Table from "../../components/ui/Table";
import usePaginate from "../../hooks/api/usePaginate";
import apiRequest from "../../utils/vendorManager/apiRequest";
import useModal from "../../hooks/ui/useModal";
import Pagination from "../../components/ui/Pagination";
import { FaEdit, FaEye, FaPlus, FaTrashAlt } from "react-icons/fa";
import Modal from "../../components/ui/utils/Modal";
import useFormInput from "../../hooks/form/useFormInput";
import { useSelector } from "react-redux";
import InputField from "../../components/ui/form/InputField";
import ProductEdit from "../../components/vendorManager/product/ProductEdit";
import { getFileUrl } from "../../utils/helper";
import StatusToggle from "../../components/ui/StatusToggle";
import ProductImageEdit from "../../components/vendorManager/product/ProductImageEdit";
import ViewDescription from "../../components/vendorManager/product/ViewDescription";

import { IoIosInformationCircleOutline } from "react-icons/io";
import Button from "../../components/ui/utils/Button";
import CreateProduct from "../../components/vendorManager/product/CreateProduct";
import EditProduct from "../../components/vendorManager/product/EditProduct";
import usePost from "../../hooks/api/usePost";


const Product = () => {
    const {
        currentPage,
        data,
        error,
        setFilters: setImportFilters,
        fetchData,
        limit,
        loading,
        setPage,
        setSorting,
        sort,
        totalItems,
        totalPages,
    } = usePaginate({
        apiMethod: apiRequest.getProducts,
        dataKey: "products",
    });
  const [statusMap, setStatusMap] = useState({});

    const [products, setProducts] = useState([]);

    useEffect(() => {
        setProducts(data);
    }, [data]);

    const [search, setSearch] = useState("");
    const [filters, setFilters] = useState({});



    const { isOpen, openModal, closeModal, actionType } = useModal();
    const handleSort = (field) => {
        const order =
            sort.sortField === field && sort.sortOrder === "asc" ? "desc" : "asc";
        setSorting({ sortField: field, sortOrder: order });
    };



    const searchInitialValues = { code: "" };
    const { values, handleChange, setValues } = useFormInput(searchInitialValues);
    const debounceRef = useRef(null);

    // useEffect(() => {
    //     if (values.code !== undefined) {
    //         if (debounceRef.current) {
    //             clearTimeout(debounceRef.current);
    //         }

    //         debounceRef.current = setTimeout(() => {
    //             const filters = {};
    //             if (values.code) {
    //                 filters.code = { $regex: values.code, $options: "i" };
    //             }
    //             setFilters(filters);
    //         }, 500);
    //         return () => clearTimeout(debounceRef.current);
    //     }
    // }, [values.code]);



    const BRAND_NAME = useSelector(
        (state) => state.globalState?.siteSetting?.site_settings?.site_name
    );

    useEffect(() => {
        if (debounceRef.current) clearTimeout(debounceRef.current);

        debounceRef.current = setTimeout(() => {
            setFilters((prev) => {
                const newFilters = { ...prev };

                if (search.trim()) {
                    newFilters.name = { $regex: search.trim(), $options: "i" };
                } else {
                    delete newFilters.name;
                }
                setImportFilters(newFilters);
                return newFilters;
            });
        }, 300);

        return () => clearTimeout(debounceRef.current);
    }, [search]);


    const {
        error: productError,
        isLoading: loadingProduct,
        post,
        serverErrors,
    } = usePost(apiRequest.updateProductStatus);


    const handleStatusToggle = async (productId, newStatus) => {
        try {
            await post({
                data: {
                    body: { status: newStatus },
                    id: productId,
                },
            });

            setStatusMap((prev) => ({
                ...prev,
                [productId]: newStatus,
            }));
        } catch (error) {
            console.error("Failed to update status:", error);
            alert("Status update failed. Please try again.");
        }
    };



    return (
        <Layout>
            <Helmet>
                <title>Admin - {BRAND_NAME ?? ''}</title>
            </Helmet>

            <div className="p-4 bg-white rounded">
                <div className="flex items-center gap-1 py-2">
                    <Button
                        onClick={() => openModal({ type: "add" })}
                        variant="primary"
                        isLoading={false}
                    >
                        <div className="flex items-center justify-center gap-3">
                            <FaPlus />
                            <p>Add Menu</p>
                        </div>
                    </Button>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-[1fr_100px] gap-2 my-2">
                    <InputField
                        placeholder="Search by excel name..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    <button
                        className="py-1 text-white rounded bg-emerald-600 hover:bg-emerald-800"
                        onClick={() => setValues(searchInitialValues)}
                    >
                        Clear
                    </button>
                </div>

                <Table
                    headers={[
                        { label: "Menu Name", key: "name", sorting: true },
                        { label: "Action", key: "actionEdit", sorting: true },
                        { label: "Image", key: "image", sorting: true },
                        { label: "Status", key: "status", sorting: true },

                        { label: "Main Category", key: "mainCategory", sorting: true },
                        { label: "Category", key: "itemCategory", sorting: true },
                        { label: "Veg / Non Veg", key: "veg/nonveg", sorting: true },
                        { label: "Vendor Price", key: "vendorPrice", sorting: true },
                        { label: "Customer Price", key: "finalPrice", sorting: true },
                        // { label: "GST (%)", key: "gstAmount", sorting: true },
                        // { label: "Description", key: "Description", sorting: true },
                        // { label: "Quantity", key: "quantity", sorting: true },
                        { label: "Serial No", key: "itemNo", sorting: true },
                        { label: "Created At", key: "createdAt", sorting: true },
                        // { label: "Action", key: "action", sorting: false },
                    ]}
                    loading={loading}
                    handleSort={handleSort}
                    sort={sort}
                    error={error}
                    cols={12}
                    renderRow={
                        <tbody className="bg-white divide-y divide-gray-200">
                            {products?.map((product) => (
                                <tr
                                    key={product._id}
                                    className="transition-colors hover:bg-gray-50"
                                >
                                    <td className="px-3 py-3">
                                        <div className=" flex items-center  gap-3">
                                            <p className="font-semibold text-gray-800">
                                                {product.name || "-"}
                                            </p>


                                            <button
                                                onClick={() =>
                                                    openModal({ type: "edit", data: { state: product } })
                                                }
                                                className={`${product?.food_type === 'VEG' ? 'text-green-500 bg-green-100' : 'text-[#8b1c00dd] bg-[#8b1c0096]'} p-2 rounded-full`}
                                                title="Edit"
                                            >
                                                <FaEdit size={18} />
                                            </button>

                                            {

                                                product.description && <button
                                                    onClick={() =>
                                                        openModal({ type: "viewDescription", data: { state: product } })
                                                    }
                                                    className={`text-blue-600 bg-slate-100 p-2 rounded-full hover:bg-slate-600`}
                                                    title="View"
                                                >
                                                    <IoIosInformationCircleOutline size={18} />

                                                </button>
                                            }

                                        </div>

                                    </td>
                                    <td>
                                        {
                                            product.excelImportId == null ? (
                                                <button
                                                    onClick={() =>
                                                        openModal({ type: "editProduct", data: { state: product } })
                                                    }
                                                    className="text-red-600 hover:text-blue-800"
                                                    title="View"
                                                >
                                                    <FaEdit size={18} />
                                                </button>
                                            ) : null
                                        }


                                    </td>
                                    <td className="px-3 py-3">
                                        <div className="w-16 h-16 overflow-hidden">
                                            <img
                                                src={getFileUrl(product?.image)}
                                                alt={product?.name}
                                                onClick={() =>
                                                    openModal({ type: "editImage", data: { state: product } })
                                                }
                                                className="object-contain w-full h-full border border-gray-300 rounded"
                                            />
                                        </div>
                                    </td>


                                    <td className="px-3 py-3 text-sm">
                                       <StatusToggle
                      status={
                        statusMap[product._id] !== undefined
                          ? statusMap[product._id]
                          : product.status
                      }
                      onChange={(newStatus) =>
                        handleStatusToggle(product._id, newStatus)
                      }
                    />
                                    </td>

                                    <td className="px-3 py-3 text-sm text-gray-600">
                                        {product?.mainCategory?.name || "-"}
                                    </td>

                                    <td className="px-3 py-3 text-sm text-gray-600">
                                        {product.itemCategory || "-"}
                                    </td>

                                    <td className="px-3 py-3 text-sm text-gray-600">
                                        {product?.food_type || "-"}
                                    </td>

                                    <td className="px-3 py-3 text-sm text-gray-700">
                                        ₹{product.vendorPrice?.toFixed(2) || "0.00"}
                                    </td>

                                    <td className="px-3 py-3 text-sm text-gray-700">
                                        ₹{product.finalPrice?.toFixed(2) || "0.00"}
                                    </td>

                                    {/* <td className="px-3 py-3 text-sm text-gray-600">
                                        {product.gstAmount ? `${product.gstAmount}%` : "0%"}
                                    </td> */}
                                    {/* <td className="px-3 py-3 text-sm text-gray-600">
                                        {product.description ? `${product.description}` : ""}
                                    </td> */}

                                    {/* <td className="px-3 py-3 text-sm text-gray-600">
                                        {product.quantity || 0}
                                    </td> */}



                                    {/* Status */}
                                    <td className="px-3 py-3 text-sm text-gray-600">
                                        {product.itemNo || "-"}
                                    </td>



                                    {/* Created At */}
                                    <td className="px-3 py-3 text-xs text-gray-500">
                                        {new Date(product.createdAt).toLocaleDateString("en-IN", {
                                            year: "numeric",
                                            month: "short",
                                            day: "numeric",
                                        })}
                                    </td>

                                    {/* Action Buttons */}
                                    {/* <td className="px-3 py-3">
                                        <div className="flex justify-center gap-3">
                                            <button
                                                onClick={() =>
                                                    openModal({ type: "view", data: { state: product } })
                                                }
                                                className="text-blue-600 hover:text-blue-800"
                                                title="View"
                                            >
                                                <FaEye size={18} />
                                            </button>
                                           
                                            <button
                                                onClick={() =>
                                                    openModal({ type: "delete", data: { state: product } })
                                                }
                                                className="text-red-500 hover:text-red-700"
                                                title="Delete"
                                            >
                                                <FaTrashAlt size={18} />
                                            </button>
                                        </div>
                                    </td> */}
                                </tr>
                            ))}
                        </tbody>
                    }
                />

                {totalPages > 1 && (
                    <Pagination
                        pagination={{
                            currentPage,
                            totalPages,
                            totalItems: totalItems,
                            perPage: limit,
                        }}
                        handlePageChange={setPage}
                        loading={loading}
                    />
                )}
            </div>
            <Modal isOpen={isOpen} onClose={closeModal} size="large">

                {actionType?.type === "edit" && (
                    <ProductEdit
                        data={actionType?.data?.state}
                        closeModal={closeModal}
                        callback={fetchData}
                    />
                )}
                {actionType?.type === "editProduct" && (
                    <EditProduct
                        data={actionType?.data?.state}
                        closeModal={closeModal}
                        callback={fetchData}
                    />
                )}

                {actionType?.type === "add" && (
                    <CreateProduct
                        closeModal={closeModal}
                        callback={fetchData}
                    />
                )}

                {actionType?.type === "editImage" && (
                    <ProductImageEdit
                        data={actionType?.data?.state}
                        closeModal={closeModal}
                        callback={fetchData}
                    />
                )}

                {actionType?.type === "viewDescription" && (
                    <ViewDescription
                        data={actionType?.data?.state}
                        closeModal={closeModal}
                        callback={fetchData}
                    />
                )}

            </Modal>
        </Layout>
    );
};

export default Product;

